module.exports = __webpack_public_path__ + "static/media/ile.84433767.png";